import React from 'react'

type Props = {
  children: React.ReactNode
}

export const TopMessageSection: React.FC<Props> = (props) => {
  return (
    <div className="w-full py-4 px-4 bg-main-lightgreen rounded-sm mb-6 border border-main-green">
      {props.children}
    </div>
  )
}
